module.exports = __webpack_public_path__ + "img/logo-small.350cd6a0.png";